// Constants for category type IDs - these should ideally come from backend configuration
export const CATEGORY_TYPE_IDS = {
  INDIVIDUAL: 'CAT010',
  COMPANY: 'CAT017',
} as const;

// Helper function to check if a category type requires company name
export const requiresCompanyName = (categoryTypeId: string): boolean => {
  // For now, we assume company types require company name
  // In the future, this could be determined by a property on the category object
  return categoryTypeId === CATEGORY_TYPE_IDS.COMPANY;
};

// Helper function to map frontend customer type to backend category type ID
export const mapCustomerTypeToCategoryId = (customerType: 'individual' | 'company'): string => {
  return customerType === 'individual' ? CATEGORY_TYPE_IDS.INDIVIDUAL : CATEGORY_TYPE_IDS.COMPANY;
};

// Helper function to map backend category type ID to frontend customer type
export const mapCategoryIdToCustomerType = (categoryTypeId: string): 'individual' | 'company' => {
  return categoryTypeId === CATEGORY_TYPE_IDS.COMPANY ? 'company' : 'individual';
};
